// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1f7d813f","703":"f9f5782e"}[chunkId] + ".chunk.js";
};